import { FC } from 'react'

export interface HeartProps {
  width?: number
  height?: number
  color?: 'black' | 'white'
  filled?: boolean
  outline?: 'black' | 'white'
}

const Heart: FC<HeartProps> = ({ width, height, color = 'white', filled, outline }) => {
  return (
    <svg
      width={width || 14}
      height={height || 12}
      viewBox="0 0 14 12"
      fill={filled ? color : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1354 1.39167C10.852 0.166666 8.86871 0.166666 7.58538 1.39167L7.00205 2.03333L6.36038 1.39167C5.07705 0.166666 3.09371 0.166666 1.81038 1.39167C0.527048 2.61667 0.585381 4.65833 1.81038 5.94167L2.45205 6.58333L7.00205 11.1333L11.552 6.58333L12.1937 5.94167C13.3604 4.65833 13.3604 2.675 12.1354 1.39167Z"
        stroke={outline ?? color}
        strokeWidth="0.583333"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default Heart
